export default __webpack_public_path__ + "static/media/1591.90c85cb3.png";